// extracted by mini-css-extract-plugin
export default {"section":"AngelInfo_section__BERhH","container":"AngelInfo_container__MbPsh","title":"AngelInfo_title__aYEja","desc":"AngelInfo_desc__lRPbs"};